import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { AppState } from '../../../store/state.model';
import { NgRedux } from '@angular-redux/store';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';

/** This method intercepts the http request and set the headers required by CMS ticket creation*/
@Injectable()
export class CmsHeaderInterceptorService implements HttpInterceptor {

  /**
  * has a dependency on domain matcher to generate a dynamic X-channel
  * DomainMatcher
  **/
  constructor(public ngRedux: NgRedux<AppState>) { }

  /**
   * @event intercept Intercept any request that is triggered by APIHandler and sets the common header of the ORCH layer
   * @args domainMatcher
   * @returns The response that is being intercepted so it can continue to the Network call
   **/
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = {};
    const spec = req.params.get('spec');
    if (spec) {
      switch (spec) {
        case 'cms-service-desk-id':
        case 'cms-organization':
        case 'cms-validate-user':
        case 'cms-request-group-info':
        case 'cms-request-group-id':
        case 'cms-request-group-fields':
        case 'cms-attach-file':
        case 'cms-create-ticket':
        case 'tss-request':
        case 'authorize-cms':
          headers = this.getCmsHeaders(spec);
          break;
      }
    }

    // Remove the spec parameter from the request before sending to backend
    // We only needed it to determine which headers to add
    let params = req.params;
    if (spec) {
      params = params.delete('spec');
    }

    return next.handle(req.clone({
      setHeaders: headers,
      params: params
    }));
  }

  /**
  * getCmsHeaders Return the common headers on the request
  **/
  public getCmsHeaders(type): object {
    let headers = {
      'x-correlationid': Guid.create().toString(),
      'X-CHANNEL': 'OP_ADMIN',
    };
    switch (type) {
      case 'authorize-cms':
        const state = this.ngRedux.getState();
        const email = state && state.auth && state.auth.email ? state.auth.email.toLowerCase() : '';
        headers = Object.assign(headers, { 'email': email });
        break;
    }
    return headers;
  }
}
